import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const createLead = (payload) => api.post("/leads", payload).then((r) => r.data);
export const createSchedule = (payload) =>
  api.post("/schedule", payload).then((r) => r.data);
